import {FieldValues, RegisterOptions} from 'react-hook-form';
import {trimWhitespaces} from '@core/scripts/helper/form-input-validation/utils';

export const MAX_LENGTH_CONSTRAINTS = {
    FIRST_NAME: 20,
    LAST_NAME: 32,
};

export const MIN_LENGTH_CONSTRAINTS = {
    FIRST_NAME: 2,
    LAST_NAME: 2,
};

const regExp = {
    name: /^[a-zA-ZäÄöÖüÜßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùûÿ\s-]*$/,
    orderNumber: /^\d{8,10}$/,
}

export declare interface FirstNameValidationTexts {
    'firstname.invalid': string;
    first_name_max_length_exceeded: string;
}

export const firstNameValidation = (texts: FirstNameValidationTexts): RegisterOptions<FieldValues, string> => {
    return {
        validate: {
            format: (v) => regExp.name.test(trimWhitespaces(v)) || texts['firstname.invalid'],
            maxLength: (v) => v.length <= MAX_LENGTH_CONSTRAINTS.FIRST_NAME || texts['first_name_max_length_exceeded'],
        },
    };
};

export declare interface LastNameValidationTexts {
    'lastname.invalid': string;
    last_name_max_length_exceeded: string;
}

export const lastNameValidation = (texts: LastNameValidationTexts): RegisterOptions<FieldValues, string> => {
    return {
        validate: {
            format: (v) => regExp.name.test(trimWhitespaces(v)) || texts['lastname.invalid'],
            maxLength: (v) => v.length <= MAX_LENGTH_CONSTRAINTS.LAST_NAME || texts['last_name_max_length_exceeded'],
        },
    };
};

export declare interface OrderNumberValidationTexts {
    order_number_is_required: string;
    order_number_invalid: string;
}

export const orderNumberValidation = (texts: OrderNumberValidationTexts): RegisterOptions<FieldValues, string> => {
    return {
        validate: {
            required: (v) => Boolean(v) || texts['order_number_is_required'],
            format: (v) => regExp.orderNumber.test(v) || texts['order_number_invalid'],
        },
    };
};
